module.exports = __webpack_public_path__ + "static/media/logo-vive-create.79ec5db8.svg";